import React from 'react';
import PulseService from '@/services/pulse/PulseService';
import { useAuth } from '@/contexts/AuthContext';
import { useAuthStore } from '@/stores';

const PulseBootstrap: React.FC = () => {
  const { user } = useAuth();
  const authStore = useAuthStore();

  // Connect/disconnect based on auth hydration + token
  React.useEffect(() => {
    const token = authStore.token;
    if (authStore.isHydrated && token) {
      PulseService.connect(token);
    } else {
      PulseService.disconnect();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authStore.isHydrated, authStore.token]);

  // Maintain channel subscriptions derived from current context
  React.useEffect(() => {
    if (!authStore.isHydrated || !authStore.token) return;
    const channels: string[] = [];
    if (user?.id) channels.push(`user:${user.id}`);
    if (authStore.activeRegionId) channels.push(`region:${authStore.activeRegionId}`);
    if (authStore.activeTeamId) channels.push(`team:${authStore.activeTeamId}`);
    PulseService.setChannels(channels);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id, authStore.activeRegionId, authStore.activeTeamId, authStore.isHydrated, authStore.token]);

  return null;
};

export default PulseBootstrap;
